var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data.value)?_c('div',{staticClass:"flex items-center lg:justify-end"},[(_vm.data.warn)?_c('i',{staticClass:"md-18 text-warning mr-25"},[_vm._v("warning")]):_vm._e(),_vm._v(" "+_vm._s(_vm.data.value)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }